import { InstaPayLogo, } from "@/Svg/Svg";
import { Footer_img } from "@/Utils/BaseUrl";
import { Mail, Phone } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

const Footer = () => {
  const {t}=  useTranslation()
  return (
    <div className="w-full bottom-0 flex flex-col items-center ">
      <div className="w-auto flex  lg:flex-row flex-col items-start justify-between   gap-8">
        <div className=" lg:w-auto flex flex-col h-full justify-between  lg:gap-[14vh] gap-[8vh] lg:ml-10 ml-3">
          <div className="flex items-center  lg:mb-6 lg:mt-0 mt-4 lg:px-0 px-5">
            <InstaPayLogo width="40" height="30" />
            <span className="font-bold text-lg text-[#000] text-[30px] p-0 m-0">InstaPay</span>
          </div>

          <div className=" lg:w-[70%] w-auto lg:px-0 px-5 flex flex-col gap-0">
            <h4 className="text-[28px] font-[500] text-[#0C0A20] mb-3">
              {t("Stay connected")}
            </h4>
            <p className="text-[#555463] font-inter  font-[] leading-[var(--line-height-body-lg,28px)] tracking-[-0.18px] text-[18px]">
              {t("Sign up for our newsletter to receive the latest news, updates,and insights on new products, flash sale, discount and more greatthings from us")}
            </p>

            <div className="flex lg:flex-row flex-col w-full gap-2 mt-5">
              <input
                type={t("email")}
                placeholder="Me@mail.com"
                className="flex-1 lg:bg-[#EFF1F6] bg-transparent px-4 lg:py-auto py-2  border border-[#D1D6E0] placeholder:text-[#9AA3B2]
                 lg:rounded-[6px] text-[14px] focus:outline-none focus:border-[#0066FF]"
              />
              <button className="lg:px-6 px-2 py-2 bg-[#0066FF] text-white rounded-md font-medium text-[14px] hover:bg-[#0052CC] transition-colors">
                {t("Subscribe")}
              </button>
            </div>
          </div>
        </div>

        <div className="w-[100%] lg:flex justify-end relative  ">

          <img
            src={Footer_img}
            alt="Footer"
            className=" w-auto lg:h-[60vh] h-auto object-contain relative z-10"
          />
        </div>
      </div>

      <div className="w-full px-4">
        <div className=" bg-[#f9f9f9] w-full border-b border-[#E4E3E5] px-5  py-8 ">
          <div className=" grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
            <div>
              <h5 className="font-semibold text-[16px] text-[#000] mb-4">
                {t("Explore")}
              </h5>
              <ul className="space-y-2">
              
                <li>
                  <Link
                    to={"/trackOrders"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Track Your Order")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/returnsAndRefunds"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Returns & Refunds")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/shippingInformation"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Shipping Information")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/contactSupport"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Contact Support")}
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h5 className="font-semibold text-[16px] text-[#000] mb-4">
                {t("Shops")}
              </h5>
              <ul className="space-y-2">
                <li>
                  <Link
                    to={"/search"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("All Products")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Home")}                  </Link>
                </li>
                <li>
                  <Link
                    to={"/product-wishlist"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Wishlist")}                  </Link>
                </li>
                <li>
                  <Link
                    to={"/buy-product"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("My Cart")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/dashboard/seller"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Dashboard")}                  </Link>
                </li>
              </ul>
            </div>

            {/* <div>
              <h5 className="font-semibold text-[16px] text-[#000] mb-4">
                {t("About us")}
              </h5>
              <ul className="space-y-2">

                <li>
                  <Link
                    to={"/"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Blog")}
                  </Link>
                </li>

                <li>
                  <Link
                    to={"/"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Accessibility")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Terms of Service")}
                  </Link>
                </li>
              </ul>
            </div> */}

            <div>
              <h5 className="font-semibold text-[16px] text-[#000] mb-4">
                {t("Partner with us")}
              </h5>
              <ul className="space-y-2">
                <li>
                  <Link
                    to={"/sellOnInstaPay"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Sell on InstaPay")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/affiliateProgram"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Affiliate program")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/advertiseBrand"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Advertise Brands")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/partnerStores"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Partner Stores")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/supplierPortal"}
                    className="text-[14px] text-[#555463] font-[500] hover:text-[#000]"
                  >
                    {t("Supplier portal")}
                  </Link>
                </li>

              </ul>
            </div>


          </div>
        </div>

        <div className=" bg-[#f9f9f9]  px-2 lg:px-5 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="hidden lg:block text-[14px] text-[#0C0A20] font-[600]">
              © {new Date().getFullYear()} - {t("All rights reserved by InstaPay")}
            </p>
            <div className="flex items-center lg:flex-row flex-col gap-6 font-bold">
              <a
                href="mailto:info@InstaPay.com"
                className="text-[14px] text-[#0C0A20] font-[600] hover:text-[#000] flex items-center gap-2"
              >
                <span>
                  <Mail  />
                </span>{" "}
                info@InstaPay.com
              </a>
              <a
                href="tel:+23301323123"
                className="text-[14px] text-[#0C0A20] font-[500] hover:text-[#000] flex items-center gap-2"
              >
                <span><Phone fill="#000" size={20} /></span> +2330 - 1323 - 123
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
